import msdyn365Commerce, { IImageDimension, IViewPort } from '@msdyn365-commerce/core-internal';
import { useMemo } from 'react';

export type BaseImageSettings = {
    [K in keyof IViewPort]: Pick<IImageDimension, 'h' | 'w'>;
};

const MAX_DPR_VALUE = 2;
const MIN_DPR_VALUE = 1;

const getDpr = (skipDprAdjustment: boolean) => {
    if (skipDprAdjustment) {
        return MIN_DPR_VALUE;
    }

    if (!msdyn365Commerce.isBrowser) {
        return MAX_DPR_VALUE;
    }

    return Math.min(Math.round(window.devicePixelRatio || MIN_DPR_VALUE), MAX_DPR_VALUE);
};

const getParsedImageViewportSettings = (simpleSettings: BaseImageSettings, dpr: number): IViewPort => {
    return Object.entries(simpleSettings).reduce((acc, [key, val]) => {
        return { ...acc, [key]: { ...val, q: `w=${val.w * dpr}&h=${val.h * dpr}&m=6&f=webp&q=80` } };
    }, {} as IViewPort);
};

// skipDprAdjustment is for when the images are not large enough
// to be multiplied by the DPR
export const useImageSettings = (baseSettings: BaseImageSettings, skipDprAdjustment = false) => {
    const dpr = getDpr(skipDprAdjustment);
    const imageViewportSettings = useMemo(() => getParsedImageViewportSettings(baseSettings, dpr), [baseSettings, dpr]);

    return imageViewportSettings;
};
